/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NenkanScheduleMasterDto { 
    /**
     * 日付識別：数字<br>　　画面項目ID＝\'C000660\'
     */
    dateDiscrm?: string;
    /**
     * 日付識別（名称）：全角
     */
    dateDiscrmAname?: string;
    /**
     * スケジュールグループ番号：数字
     */
    grpNo?: string;
    /**
     * 日付（年）：数字
     */
    year?: string;
    /**
     * 月：数字
     */
    month?: string;
    /**
     * 適用開始日付：日付(yyyyMMdd)
     */
    applyStartDate?: string;
    /**
     * 適用終了日付：日付(yyyyMMdd)
     */
    applyEndDate?: string;
    /**
     * 日付：数字
     */
    date?: string;
    /**
     * 間隔：数字
     */
    interv?: string;
    /**
     * 更新通番号：数字
     */
    updateSrno?: string;
}

